import React from 'react';
import { LeafIcon, RecycleIcon, SproutIcon, Trash2Icon } from 'lucide-react';
import { collections, materials, type MaterialId } from '../../data/collectes';
const icons: Record<MaterialId, typeof RecycleIcon> = {
  recyclage: RecycleIcon,
  ordures: Trash2Icon,
  organiques: LeafIcon,
  verts: SproutIcon
};
const MAX_VISIBLE = 3;
export function CollectionList() {
  const [next, ...upcoming] = collections;
  const NextIcons = next.materials.slice(0, MAX_VISIBLE);
  return <section aria-labelledby="collections-title" data-id="element-637" data-mp="tx1g5d2fx28m">
      

      <div className="mt-5 grid gap-5 sm:grid-cols-2" data-id="element-638" data-mp="twje1zt3jtss">
        {/* Next collection — primary */}
        <article className="flex flex-col gap-6 rounded-3xl bg-ville-navy p-7 text-white shadow-xl shadow-ville-navy/20 sm:col-span-2 sm:flex-row sm:items-center sm:justify-between sm:gap-10" data-id="element-639" data-mp="ez92kqggenx2">
          <div className="min-w-0" data-id="element-640" data-mp="2zp85ummk08tc">
            <p className="text-3xl font-extrabold leading-tight tracking-tight" data-id="element-641" data-mp="2zsck6ctqgkxq">{next.weekday}</p>
            <p className="mt-1 text-sm text-white/70" data-id="element-642" data-mp="34mqaw1xga3w2">{next.date}</p>
            <span className="mt-3 inline-flex w-fit items-center gap-2 rounded-full bg-ville-lime px-3 py-1 text-xs font-bold uppercase tracking-wider text-ville-navy" data-id="element-643" data-mp="2thktir6tb8ez">
              Collection under way
            </span>
          </div>

          <ul className="flex shrink-0 items-start justify-between gap-2 sm:justify-end sm:gap-6" data-id="element-644" data-mp="2ximlqo2bak7g">
            {NextIcons.map(id => {
            const Icon = icons[id];
            return <li key={id} className="flex min-w-0 flex-1 flex-col items-center text-center sm:flex-none sm:w-20" data-id="element-645" data-mp="3cdsq76lreayo">
                  <span className="grid h-11 w-11 place-items-center rounded-full bg-white/10 text-ville-lime" aria-hidden="true" data-id="element-646" data-mp="3l87g033x13w1">
                    <Icon className="h-5 w-5" data-id="element-647" data-mp="3h6djm70r6m1o" />
                  </span>
                  <span className="mt-2 text-[11px] font-bold leading-tight text-white" data-id="element-648" data-mp="3v654mrpot2p6">
                    {materials[id].label}
                  </span>
                </li>;
          })}
          </ul>
        </article>

        {/* Following collections */}
        {upcoming.map(collection => {
        const visible = collection.materials.slice(0, MAX_VISIBLE);
        const extra = collection.materials.length - visible.length;
        return <article key={collection.id} className="flex flex-col rounded-3xl border border-slate-200 bg-white p-7" data-id="element-649" data-mp="2wtizas71sr6d">
              <span className="text-xs font-bold uppercase tracking-wider text-ville-blue" data-id="element-650" data-mp="31mvgih9edvp3">Next collection</span>
              <p className="mt-2 text-xl font-extrabold leading-tight text-ville-navy" data-id="element-651" data-mp="36mhrek1r6zuq">
                {collection.weekday} {collection.date}
              </p>

              <ul className="mt-6 flex items-start justify-between gap-2" data-id="element-652" data-mp="3fm4vjdlvajrh">
                {visible.map(id => {
              const Icon = icons[id];
              return <li key={id} className="flex min-w-0 flex-1 flex-col items-center text-center" data-id="element-653" data-mp="1l728dmkajdrq">
                      <span className="grid h-11 w-11 place-items-center rounded-full bg-ville-mist text-ville-deep" aria-hidden="true" data-id="element-654" data-mp="1q65frdnqtw2v">
                        <Icon className="h-5 w-5" data-id="element-655" data-mp="1ino00pp9xl1g" />
                      </span>
                      <span className="mt-2 text-[11px] font-bold leading-tight text-ville-navy" data-id="element-656" data-mp="1dve1ila3fcnk">
                        {materials[id].label}
                      </span>
                    </li>;
            })}
                {extra > 0 && <li className="flex min-w-0 flex-1 flex-col items-center text-center" data-id="element-657" data-mp="13yrmwe8d1htz">
                    <span className="grid h-11 w-11 place-items-center rounded-full border border-dashed border-slate-300 text-sm font-bold text-ville-deep" data-id="element-658" data-mp="21kfgkrdflm1t">
                      +{extra}
                    </span>
                    <span className="mt-2 text-[11px] font-bold leading-tight text-slate-500" data-id="element-659" data-mp="1rlzmcfj3xwo3">
                      {extra > 1 ? 'collections' : 'collection'}
                    </span>
                  </li>}
              </ul>
            </article>;
      })}
      </div>
    </section>;
}